import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useGoogleAnalytics } from '../../utils/useGoogleAnalytics';

function GoogleAnalyticsProvider() {
  const location = useLocation();
  const { initializeAnalytics } = useGoogleAnalytics();
  
  // Inicializar GA4 cuando el componente se monta
  useEffect(() => {
    initializeAnalytics();
  }, [initializeAnalytics]);

  return null;
}

export default GoogleAnalyticsProvider;
